module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 11.24184e94.png";